import { z } from 'zod';

/**
 * System Administration Schemas
 * System health, monitoring, and operational concerns
 */

// === System Status Enums ===

export const HealthStatusSchema = z.enum(['ok', 'degraded', 'error'], {
  error: "Invalid health status. Must be one of: ok, degraded, error"
});

export const DependencyStatusSchema = z.enum(['ok', 'error'], {
  error: "Invalid dependency status. Must be one of: ok, error"
});

// === HTTP Method Enum ===

export const HttpMethodSchema = z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH'], {
  error: "Invalid HTTP method. Must be one of: GET, POST, PUT, DELETE, PATCH"
});

// === Queue Management Schemas ===

export const QueueJobCleanStatusSchema = z.enum(['completed', 'failed'], {
  error: "Invalid queue job clean status. Must be one of: completed, failed"
});

// === Stats Schemas ===

export const StatsCountSchema = z.object({
  total: z.number().int().min(0),
  public: z.number().int().min(0),
  private: z.number().int().min(0),
  recentlyUpdated: z.number().int().min(0)
});

// Export TypeScript types
export type HealthStatus = z.infer<typeof HealthStatusSchema>;
export type DependencyStatus = z.infer<typeof DependencyStatusSchema>;
export type HttpMethod = z.infer<typeof HttpMethodSchema>;
export type QueueJobCleanStatus = z.infer<typeof QueueJobCleanStatusSchema>;
export type StatsCount = z.infer<typeof StatsCountSchema>;
